import axios from "axios";
import { client } from "../Context/orgContext";
import { getBearerToken } from "./CommonService";

export const createPlan = async (data) => {
    const token = getBearerToken();
    return axios
        .post(
        `/api/v1/endUser/hep-exercise/getHepPlanUrl`,
        {
            "organisation_domain_name": client,
            "exercise_data": data
        },
        {
            headers: {
            "Authorization": `Bearer ${token.jwt}`,
            "Content-Type": "application/json",
            },
        }
        )
        .then((res) => {
        return res.data
        }).catch((err) => {
        return err;
        });
};

export const generateReportLink = async (urlToken) => {
    const token = getBearerToken();
    return axios
        .get(
        `/api/v1/endUser/hep-exercise/getHepReportLink?encryptedToken=${urlToken}`,
        // {},
        {
            headers: {
            "Authorization": `Bearer ${token.jwt}`,
            },
        }
        )
        .then((res) => {
        return res.data
        }).catch((err) => {
        return err;
        });
};